import type { RouteRecordRaw } from 'vue-router'

const TeamClasses = () => import('@/modules/Classes/RouteTeamClasses.vue')

const classesRoute: RouteRecordRaw = {
  path: '/classes',
  name: 'Classes',
  component: TeamClasses,
  meta: { requiresAuth: true, requiresAbility: 'view_full_datasets' },
  children: [{ path: ':editClassId', name: 'ClassesEdit', component: TeamClasses }],
}

export default classesRoute
